<template>
  <app-modal
    :modal-id="modalId"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="full-width"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">Muestreo</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
        selectedUrl
            ? `/accreditations/officio/storeCheckSampling/${inputs.id}`
            : `/accreditations/officio/storeCheckSampling`
        "
      >
        <table
          class="table table-sm table-striped mt-2"
          v-if="['OENY'].includes(activity)"
        >
          <thead>
            <tr>
              <th scope="col">Seleccionar</th>
              <th scope="col">Organización</th>
              <th scope="col">Categoría</th>
              <th scope="col">Campo de ensayo</th>
              <th scope="col">PRODUCTO O MATERIAL A MUESTREAR</th>
              <th scope="col">PROCEDIMIENTO DE MUESTREO (Procedimiento normalizado y procedimiento interno, si aplica)</th>
              <th scope="col">MÉTODO DE REFERENCIA DEL MUESTREO (revisión/edición) (5)</th>
              <th scope="col">MÉTODOS DE ENSAYO A LOS QUE APLICA (Procedimiento interno y/o método de referencia con su revisión/edición)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(samp, key) in sampling" :key="key">
              <td class="align-middle text-center">
                <input
                  type="checkbox"
                  id="inputs_approved"
                  v-model="samp.is_checked"
                />
              </td>
              <td class="align-middle">
                {{ samp.org ? (samp.org.country_id == 1 ? `${samp.org.canton.name}` : `${samp.org.city}`): "Matriz" }}
              </td>
              <td class="align-middle">
                {{ samp.level_3.value }}
              </td>
              <td class="align-middle">
                {{ samp.level_4.value }}
              </td>
              <td class="align-middle">
                <span v-html="samp.product"></span>
              </td>
              <td class="align-middle">
                <span v-html="samp.process"></span>
              </td>
              <td class="align-middle">
                <span v-html="samp.method"></span>
              </td>
              <td class="align-middle">
                <span v-html="samp.test_methods"></span>
              </td>
            </tr>
          </tbody>
            
        </table>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { axiosGet } from "@/app/helpers/AxiosHelper";

export default {
name: "OfficioSamplingModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    activity: String,
    activityId: Number,
    userId: Number,
    accAppId: String,
  },
  data() {
    return {
      preloader: false,
      modalId: "officio-sampling-modal",
      sampling: {},
      showSave: false,
    };
  },
  created() {
    this.dataInfo();
  },
  methods: {
    submit() {
      let i = 0;
      this.sampling = this.sampling.map((sampl) => {
        return {
          ...sampl, 
          is_checked: sampl.is_checked ? 1 : 0, 
        };
      });

      this.save({ sampling: this.sampling, accAppId: this.accAppId, activityId: this.activityId });
    },
    afterSuccess(response) {
      this.$toastr.s(this.$t("created_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },
    dataInfo() {
      this.preloader = true;
      axiosGet(
        `/accreditations/officio/showSampling/${this.userId}?activityId=${this.activityId}&&accAppId=${this.accAppId}`
      )
        .then((response) => {
          if (response.status == 200) {
            this.sampling = response.data;

            this.sampling = this.sampling.map((scope) => {
              if (sampling.status_id == 98) {
                return {
                ...sampling, 
                is_checked: 1, 
              };
              } else {
                return {
                ...sampling, // Copia todas las propiedades existentes en el objeto scope
                is_checked: 0, // Agrega la propiedad is_checked con el valor inicial false
              };
              }
            });

            if (response.data.length > 0) {
              this.showSave = true;
            }
            
          }
        
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  }
}
</script>

<style>

</style>